import React from 'react';
import { useReferencedComponent } from '@hooks/useReferencedComponent';
import { Results } from '@components/SectionBlocks/Testshowcase/Results/Results';
import { TestResultBlock } from '@appTypes/testResultBlock';
import { FormBlock } from '../Form/FormBlock';
import { DynamicForm } from '../Form/FormBlock.types';
import { FeaturedVehicleResultBlock } from '../FeaturedVehicleResultSerializer/FeaturedVehicleResultSerializer';

export interface ReferencedComponentProps {
  type: 'referencedComponent';
  documentId: string;
}

export interface ReferencedComponentSerializerProps {
  value: ReferencedComponentProps;
}

export type ReferencedComponentData =
  | (DynamicForm & { type: 'dynamicForm' })
  | (React.ComponentProps<typeof FeaturedVehicleResultBlock>['value'] & { type: 'bodyFeaturedVehicleTestResult' })
  | (TestResultBlock & { type: 'testResultBlockGlobal' });

export const ReferencedComponentContent = ({ data }: { data: ReferencedComponentData | null }) => {
  if (data?.type === 'dynamicForm') {
    return <FormBlock value={{ _key: '', _type: 'dynamicForm', dynamicForm: data }} />;
  }
  if (data?.type === 'bodyFeaturedVehicleTestResult') {
    return <FeaturedVehicleResultBlock value={data} />;
  }
  if (data?.type === 'testResultBlockGlobal') {
    return <Results block={data} />;
  }

  return null;
};

export const ReferencedComponentBlock = ({ value: { documentId } }: ReferencedComponentSerializerProps) => {
  const data = useReferencedComponent(documentId) as ReferencedComponentData | null;

  return <ReferencedComponentContent data={data} />;
};
